
import { useNavigate } from "react-router-dom"
import ShowMoreText from "react-show-more-text";

export const ClientSays = () => {
  const navigate = useNavigate()
  return (
    <>
      <div className="row p-3 px-md-5 pt-5  mx-auto charchole" >
        <div className="col-12 col-lg-10 px-lg-5 mx-auto text-center">
          <h3 className="fw-bold text-white">WHAT CLIENT SAY?</h3>
          <div className="zoom-in-out-box2 m-auto">
            <hr />
          </div>
          <h6 className=" pt-3 border-dark text-white ">
            We truly valuethe feedback from our clients, as it helps us grow and improve. Every opinion, whether positive or constructive, is appreciated and welcomed. Thank you for being a part of our journey.
          </h6>
        </div>

        {/* <div className="col-12 col-md-4 mt-5">
          <div className="px-3 pt-3 border charchole client_says">
            <p className="text-white font_size">"Under tight deadlines and with high
              expectations, CDAT has delivered the Public Grievance Management System both Mobile App and Web Application
              suited to the requirement of Urban Local Body , The Citizens of City have given a overwhelming reponse , The
              app has seen 30k plus downloads and still counting in very short time , Well Done Team CDAT".</p>
          </div>
          <div className="client_arrow"></div>
          <div className="pt-2">
            <div className="row">
              <div className="col-3">
                <img src="Assets/Images/Home/amil.jpg" alt="" className="client_img" />
              </div>
              <div className="col-9">
                <span className="fw-bold">Commissioner</span><br />
                <p className="font_size pt-2"><b>Nagpur Municipal Corporation </b></p>
              </div>

            </div>
          </div>
        </div>

        <div className="col-12 col-md-4 mt-5">
          <div className="px-3 pt-3 border charchole client_says">
            <p className="text-white font_size" >E Tapal Police Department is a internet & intranet base solution for all
              government functionaries to monitor their Daily Branch, Section and
              Table wise letter and file movement of their own Office. LFMS is helping
              for electronic letter inwards, letter movement from one desk to another
              desk, creation of desk wise files and letter draft for approval,
              dispatch of letters, desk wise setting due dates and reminders, desk
              wise queries and report and migration of letters and files from one desk
              to another desk.</p>
          </div>
          <div className="client_arrow"></div>
          <div className="pt-2">
            <div className="row">
              <div className="col-3">
                <img src="Assets/Images/Home/avtar.jpg" alt="" className="client_img" />
              </div>
              <div className="col-9">
                <span className="fw-bold">Superintendent of Police</span><br />
                <p className="font_size pt-2"><b>District Ahmednagar</b></p>
              </div>

            </div>
          </div>
        </div>

        <div className="col-12 col-md-4 mt-5">
          <div className="p-3 border charchole client_says">
            <span className="text-white font_size">"The Letter and File Management System designed
              and Developed by CDAT has really brought transparency in the Government Domain , The software is very light
              , easy to operate with interactive dashboards, CDAT is a company who understands the government domain,
              Their expertise empower the digital transformation in Government Offices smoothly and efficiently, Good Job
              Team CDAT".</span>
          </div>
          <div className="client_arrow"></div>
          <div className="pt-2">
            <div className="row">
              <div className="col-3">
                <img src="Assets/Images/Home/amil.jpg" alt="" className="client_img" />
              </div>
              <div className="col-9">
                <span className="fw-bold">Project Director</span><br />
                <p className="font_size pt-2"><b>State Agriculture Department</b></p>
              </div>

            </div>
          </div>
        </div> */}

        <div className="row px-lg-5">
          <div className="col-12 col-md-6 col-lg-6 mx-auto pt-5">
            <blockquote className="blockquote blockquote-custom bg-white px-3 pt-2 shadows rounded">

              <video width="100%" height="300px" poster="Assets/Images/video/nagpur-01.PNG" controls>
                <source src="Assets/Images/video/nmc.mp4" type="video/mp4" />
              </video>

              <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
              <p className="mt-2 font-italic fs-6 " style={{ textAlign: 'justify' }}>"Under tight deadlines and with high expectations, CDAT has delivered
                the Public Grievance Management System both Mobile App and Web Application suited to the requirement of
                Urban Local Body , The Citizens of City have given a overwhelming reponse , The app has seen 30k plus
                downloads and still counting in very short time , Well Done Team CDAT".</p>

              <footer className="blockquote-footer py-4 border-top" style={{ marginTop: '60px' }}><b className="text-dark">Commissioner</b>
                <cite title="Source Title"> Nagpur Municipal Corporation</cite>
              </footer>
            </blockquote>
          </div>
          <div className="col-12 col-md-6 col-lg-6 mx-auto pt-5">

            <blockquote className="blockquote blockquote-custom bg-white pt-3 pb-4 px-3 shadows rounded">

              <iframe width="100%" height="280px" src="https://www.youtube.com/embed/pW0OdIeWrbk"
                title="Ahmednagar पोलिसांची नागरिकांसाठी &#39;ई-टपाल&#39; प्रणाली, पोलीस अधीक्षक Manoj Patil यांची संकल्पना |Police"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen></iframe>

              <div className="blockquote-custom-icon bg-golden shadow-sm "><i className="fa fa-quote-left text-white"></i></div>
              <p className="mb-0 mt-2 font-italic fs-6" style={{ textAlign: 'justify' }}>
                E Tapal Police Department is a internet & intranet base solution for all government functionaries to monitor their Daily Branch, Section & Table wise letter & file movement of their own Office. LFMS is helping for electronic letter inwards, letter movement from one desk to another desk, creation of desk wise files & letter draft for approval, dispatch of letters, desk wise setting due dates & reminders, desk wise queries & report & migration of letters & files from one desk to another desk.

              </p>

              <footer className="blockquote-footer pt-4 mt-lg-4 border-top"><b className="text-dark">Superintendent of Police</b>
                <cite title="Source Title"> District Ahmednagar</cite>
              </footer>

            </blockquote>

          </div>

          {/* RTO Thane Sanwad */}
          {/* <div className="col-12 col-md-6 col-lg-6 mx-auto pt-5">
            <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadows rounded">

              <video width="100%" height="300px" poster="Assets/Images/video/RTOThaneImage.png" controls>
                <source src="Assets/Images/video/RTOThane.mp4" type="video/mp4" />
              </video>

              <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
              <p className="mt-2 font-italic fs-6 " style={{ textAlign: 'justify' }}>
                <span style={{ fontWeight: 'bold' }}>" आर.टी.ओ ठाणे संवाद " </span>
                <ShowMoreText
                  lines={4}
                  more="Show more"
                  less="Show less"
                  anchorClass="read-more"
                  anchorStyle={{ color: 'blue', cursor: 'pointer' }}
                >
                  – WhatsApp Chatbot (8369532705)
                  The RTO Thane Sanwad WhatsApp Chatbot is a citizen-friendly digital assistant designed to help users access Contactless License Services through the Parivahan Sarathi Portal. It provides step-by-step guidance for services such as issuing learner’s licences, duplicate licences, renewal of licences, change of name/address, and hazardous material endorsements. Users can simply send a message on WhatsApp to get assistance with licence number validation, required documents, forms, and fee details, along with instructions for completing the online application process. This makes the system convenient, transparent, and efficient, reducing the need for physical visits to the RTO office.
                </ShowMoreText></p>

              <footer className="blockquote-footer pt-4 mt-4 border-top" style={{ marginTop: '50px' }}><b className="text-dark">RTO Thane</b>
                <cite title="Source Title" style={{ fontSize: '16px' }}> आर.टी.ओ ठाणे संवाद</cite>
              </footer>
            </blockquote>
          </div> */}

          {/* Zilha Parishad Pune */}
          {/* <div className="col-12 col-md-6 col-lg-6 mx-auto pt-5">
            <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadows rounded">

              <video width="100%" height="300px" poster="Assets/Images/video/eSanchitPhoto.png" controls>
                <source src="Assets/Images/video/eSanchit01.mp4" type="video/mp4" />
              </video>

              <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
              <p className="mt-2 font-italic fs-6 " style={{ textAlign: 'justify' }}>
                <span style={{ fontWeight: 'bold' }}>" ई - संचित " </span>
                <ShowMoreText
                  lines={4}
                  more="Show more"
                  less="Show less"
                  anchorClass="read-more"
                  anchorStyle={{ color: 'blue', cursor: 'pointer' }}
                >
                  - We are pleased to share that the <strong>“e-Sanchit”</strong> project of Zilla Parishad Pune has been successfully inaugurated by Hon. Minister, Maharashtra State. The software has greatly streamlined our processes with its five powerful modules:
                  <strong> SOPI </strong> – Ensures that PPO and pension are issued on the very day of retirement.
                  <strong> MRMS</strong> – Provides a fully online medical reimbursement system for faster and more transparent claim processing.
                  <strong> GPF</strong> – Offers monthly online credit updates with SMS alerts and quick disbursement of funds.
                  <strong> GIS</strong> – Enables timely settlement of group insurance benefits for employees.
                  Deposit Accounting & Refund – Automates challans, bills, deductions, and deposits for accurate and traceable transactions
                  .
                </ShowMoreText>
              </p>

              <footer className="blockquote-footer pt-4 mt-4 border-top" style={{ marginTop: '50px' }}><b className="text-dark">Hon. Ajit Pawar</b>
                <cite title="Source Title" style={{ fontSize: '16px' }}> Deputy Chief Minister of Maharashtra</cite>
              </footer>
            </blockquote>
          </div> */}

        </div>
        {/* <div className="text-center col-lg-9 mx-auto ">
          <h5 className="lh-lg client_title">"Perfection is Achieved Not When There Is Nothing More to Add, But When There Is
            Nothing Left to Take Away"</h5>
        </div> */}

        <div className="col-12 pt-5 pt-lg-0 mt-4">
          <p className="text-center ">

            <button onClick={() => navigate('/ClientReviews?ScreenName=Clients Review&Name=Clients')} type="submit" className="silver_bg px-4 py-3 border ">See More Reviews</button>
          </p>
        </div>
      </div>
    </>
  )
}